import React from "react";
import "./subscription-details.css";
import Radio from "../Radio-Button/Radio";
import ImageLogo from "../../../images/boldlogo.png";

function SubscriptionDetails() {
  return (
    <>
      <div className="d-flex align-items-center pb-2 brand-head">
        <div>
          <div className="default_circle border-primary align-self-center">
            <img src={ImageLogo} alt="payulogo" width="20" />
          </div>
        </div>
        <div className="brand-name">
          <h2 className="font-weight-bold darkgrey ">Hangama Music</h2>
        </div>
      </div>

      <div className="sub-features">
        <ul>
          <li>Lorem Plan HD Music</li>
          <li>Lorem Plan Song &amp; Movies</li>
          <li>Lorem Ipsum</li>
          <li>Unlimited Lorem Ipsum</li>
          <li>Enjoy Subscription on to 5 screens</li>
        </ul>
      </div>

      <div className="d-flex">
        <div className="check">
          <Radio title="₹149 / 1 month"></Radio>
        </div>
        <div className="check">
          <Radio title="₹1499 / 1 year"></Radio>
        </div>
      </div>
    </>
  );
}

export default SubscriptionDetails;
